export default "__VITE_ASSET__CLaAVSyZ__"